import { useQuery } from '@tanstack/react-query';
import { http } from '../jobs/api/http.js';

async function fetchSalesStats() {
  const { data } = await http.get('/api/redis/sales-dashboard/stats');
  return data;
}

async function fetchProductSummary() {
  const { data } = await http.get('/api/redis/sales-dashboard/product-summary');
  return data;
}

export function useSalesDashboardStats() {
  return useQuery({
    queryKey: ['sales-dashboard', 'stats'],
    queryFn: fetchSalesStats,
    refetchInterval: 10000,
    staleTime: 5000,
  });
}

export function useSalesProductSummary() {
  return useQuery({
    queryKey: ['sales-dashboard', 'product-summary'],
    queryFn: fetchProductSummary,
    refetchInterval: 10000,
    staleTime: 5000,
  });
}

async function fetchDeliveryTokens() {
  const { data } = await http.get('/api/redis/sales-dashboard/delivery-tokens');
  return data;
}

export function useSalesDeliveryTokens() {
  return useQuery({
    queryKey: ['sales-dashboard', 'delivery-tokens'],
    queryFn: fetchDeliveryTokens,
    refetchInterval: 8000,
    staleTime: 4000,
  });
}
